import React from 'react';
import { SalesButton } from './SalesButton';
import { CheckCircle } from 'lucide-react';
export function HeroSection() {
  return <section className="relative bg-gradient-to-b from-rose-50 to-white pt-8 pb-12 px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-14">
      <div className="max-w-7xl mx-auto" data-id="element-15">
        <div className="text-center max-w-4xl mx-auto mb-8" data-id="element-16">
          <div className="inline-flex items-center px-3 py-1.5 rounded-full bg-rose-100 text-rose-800 text-sm font-semibold mb-4" data-id="element-17">
            <span className="mr-2" data-id="element-18">🔥</span> Para la mujer que está harta de
            decir "mañana empiezo"
          </div>

          <h1 className="text-4xl md:text-6xl font-extrabold text-slate-900 tracking-tight mb-6 leading-tight" data-id="element-19">
            Cómo hackear tu cerebro en{' '}
            <span className="text-rose-600" data-id="element-20">5 segundos</span> para mover tu
            cuerpo sin usar fuerza de voluntad.
          </h1>

          <p className="text-xl md:text-2xl text-slate-600 mb-8 max-w-2xl mx-auto" data-id="element-21">
            No eres floja, tu cerebro te está engañando. Descubre el método de
            21 días para recuperar el control y dejar la culpa atrás.
          </p>

          <SalesButton className="w-full sm:w-auto text-xl px-10 py-5" onClick={() => document.getElementById('oferta')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-22">
            QUIERO MI PLAN DE 21 DÍAS
          </SalesButton>

          <p className="mt-4 text-sm text-slate-500" data-id="element-23">
            Oferta especial $6.36 (Antes $37) • Acceso Inmediato
          </p>
        </div>

        <div className="relative mt-8 lg:mt-10" data-id="element-24">
          <div className="absolute inset-0 flex items-center justify-center" aria-hidden="true" data-id="element-25">
            <div className="w-full h-full bg-gradient-to-tr from-rose-200 to-purple-200 opacity-30 blur-3xl transform scale-110 rounded-full" data-id="element-26"></div>
          </div>
          <img src="https://cdn.magicpatterns.com/uploads/2xjLH2ErdpHjNYGBG43wNj/Disciplina_Anti_Flojera.png" alt="Disciplina Anti-Flojera Programa Digital" className="relative mx-auto w-full max-w-4xl drop-shadow-2xl rounded-xl transform hover:scale-[1.01] transition-transform duration-500" data-id="element-27" />
        </div>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-4 text-center" data-id="element-28">
          {['Sin dietas extremas', 'Sin retos de 75 días', 'Solo disciplina real'].map((item, i) => <div key={i} className="flex items-center justify-center space-x-2 text-slate-700 font-medium bg-white/50 py-3 rounded-lg backdrop-blur-sm" data-id="element-29">
              <CheckCircle className="h-5 w-5 text-green-500" data-id="element-30" />
              <span data-id="element-31">{item}</span>
            </div>)}
        </div>
      </div>
    </section>;
}